//  This functions loads all the custom made styles options to load in StyleManager of GrapesJs
const LoadStyles = () => {
    const tempStyles = [

        {
          name: "General",
          open: true,
          buildProps: [
            "float",
            "display",
            "position",
            "top",
            "right",
            "left",
            "bottom"
          ]
        },
        {
          name: "Dimension",
          open: false,
          buildProps: [
            "width",
            "height",
            "max-width",
            "min-height",
            "margin",
            "padding"
          ]
        },
        {
          name: "Typography",
          open: false,
          buildProps: [
            "font-family",
            "font-size",
            "font-weight",
            "letter-spacing",
            "color",
            "line-height",
            "text-align",
            "text-shadow"
          ],
          properties: [
            {
              name: "Font size",
              property: "font-size",
              type: "integer",
              units: ['px', 'em', 'rem', '%', 'vw'],
            }
          ]
        },
        {
          name: "Decorations",
          open: false,
          buildProps: [
            "border-radius-c",
            "background-color",
            "border-radius",
            "border",
            "box-shadow",
            "background"
          ],
          properties:[
            {
            name: 'Gradient',
            property: 'background-image',
            type: 'gradient',
            defaults: ''
          },
          {
            name: 'Custom gradient',
            property: 'background-image',
            defaults: 'none'
          }
        ]
        },
        {
          name: "Extra",
          open: false,
          buildProps: [
            "opacity",
            "transition",
            "perspective",
            "transform"
          ],
          properties:[
            {
              name: 'Overflow-X',
              property: 'overflow-x',
              type: 'select',
              defaults: 'visible',
              list:[
                { value: 'visible', name: 'Visible'},
                { value: 'hidden', name: 'Hidden'},
                { value: 'scroll', name: 'Scroll'},
                { value: 'auto', name: 'Auto'},
                { value: 'initial', name: 'Initial'},
                { value: 'inherit', name: 'Inherit'}
              ]
            },
            {
              name: 'Overflow-Y',
              property: 'overflow-y',
              type: 'select',
              defaults: 'visible',
              list:[
                { value: 'visible', name: 'Visible'},
                { value: 'hidden', name: 'Hidden'},
                { value: 'scroll', name: 'Scroll'},
                { value: 'auto', name: 'Auto'},
                { value: 'initial', name: 'Initial'},
                { value: 'inherit', name: 'Inherit'}
              ]
            }
          ]
        },
        {
          name: "Flex",
          open: false,
          properties: [
            {
              name: "Flex Container",
              property: "display",
              type: "select",
              defaults: "block",
              list: [
                { value: "block", name: "Disable" },
                { value: "flex", name: "Enable" }
              ]
            },
            {
              name: "Flex Parent",
              property: "label-parent-flex",
              type: "integer"
            },
            {
              name: "Direction",
              property: "flex-direction",
              type: "select",
              defaults: "row",
              list: [
                {
                  value: "row",
                  name: "Row",
                  title: "Row"
                },
                {
                  value: "row-reverse",
                  name: "Row reverse",
                  title: "Row reverse"
                },
                {
                  value: "column",
                  name: "Column",
                  title: "Column"
                },
                {
                  value: "column-reverse",
                  name: "Column reverse",
                  title: "Column reverse"
                }
              ]
            },
            {
              name: "Justify",
              property: "justify-content",
              type: "select",
              defaults: "flex-start",
              list: [
                {
                  value: "flex-start",
                  className: "icons-flex icon-just-start",
                  title: "Start"
                },
                {
                  value: "flex-end",
                  title: "End",
                  className: "icons-flex icon-just-end"
                },
                {
                  value: "space-between",
                  title: "Space between",
                  className: "icons-flex icon-just-sp-bet"
                },
                {
                  value: "space-around",
                  title: "Space around",
                  className: "icons-flex icon-just-sp-ar"
                },
                {
                  value: "center",
                  title: "Center",
                  className: "icons-flex icon-just-sp-cent"
                }
              ]
            },
            {
              name: "Align items",
              property: "align-items",
              type: "select",
              defaults: "center",
              list: [
                {
                  value: "flex-start",
                  title: "Start",
                  className: "icons-flex icon-al-start"
                },
                {
                  value: "flex-end",
                  title: "End",
                  className: "icons-flex icon-al-end"
                },
                {
                  value: "stretch",
                  title: "Stretch",
                  className: "icons-flex icon-al-str"
                },
                {
                  value: "center",
                  title: "Center",
                  className: "icons-flex icon-al-center"
                }
              ]
            },
            {
              name: "Flex Children",
              property: "label-parent-flex",
              type: "integer"
            },
            {
              name: "Order",
              property: "order",
              type: "integer",
              defaults: 0,
              min: 0
            },
            {
              name: "Flex",
              property: "flex",
              type: "composite",
              properties: [
                {
                  name: "Grow",
                  property: "flex-grow",
                  type: "integer",
                  defaults: 0,
                  min: 0
                },
                {
                  name: "Shrink",
                  property: "flex-shrink",
                  type: "integer",
                  defaults: 0,
                  min: 0
                },
                {
                  name: "Basis",
                  property: "flex-basis",
                  type: "integer",
                  units: ["px", "%", ""],
                  unit: "",
                  defaults: "auto"
                }
              ]
            },
            {
              name: "Align self",
              property: "align-self",
              type: "select",
              defaults: "auto",
              list: [
                {
                  value: "auto",
                  name: "Auto"
                },
                {
                  value: "flex-start",
                  title: "Start",
                  className: "icons-flex icon-al-start"
                },
                {
                  value: "flex-end",
                  title: "End",
                  className: "icons-flex icon-al-end"
                },
                {
                  value: "stretch",
                  title: "Stretch",
                  className: "icons-flex icon-al-str"
                },
                {
                  value: "center",
                  title: "Center",
                  className: "icons-flex icon-al-center"
                }
              ]
            }
          ]
        }
      ]

    return tempStyles;
}

export default LoadStyles;